import { Config, CoreHelpers } from 'services/core/config';

const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';

export const isValidEmail = (value: string) => {
  return CoreHelpers.validations.isValidEmail(value);
};

export const Logout = () => {
  Config.removeTokenAuthUser();
  localStorage.removeItem(TOKEN_NAME);
  sessionStorage.removeItem(TOKEN_NAME);
  window.location.replace(`/logout`);
};

export const ClearUserAuth = () => {
  Config.removeTokenAuthUser();
  localStorage.removeItem(TOKEN_NAME);
  sessionStorage.removeItem(TOKEN_NAME);
};

export const REGEX = {
  TEXT_AND_NUMBER: /[^0-9A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ ]+/g,
  TEXT_ONLY: /[^A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ ]+/g,
  NUMBER: /[^0-9-]+|-(.*)-/g,
};
